export default __webpack_public_path__ + "static/SRUS SP55 - Especification Del Producto y Datos Técnicos-306c4e9e7faedfc3a8cd7656c4f44d7f.pdf";